export const sceneList = [
  // 'topview',
  // 'topview-tang-07',
  // 'topview-tang-15',
  // 'topview-tang-22',
  // 'topview-tang-27',
  // 'tong-the-toan-canh-01',
  'jasari-scene',
  'jasari-scene-03',
  'jasari-scene-04-17',
  'jasari-scene-18-33',
];

export const mikaSceneList = [
  'mika-topview',
  'mika-topview-tang-07',
  'mika-topview-tang-15',
  'mika-topview-tang-25',
  'mika-topview-tang-27',
];

export const apartmentList = [
  'can-ho-1pn-scene-1',
  'can-ho-1pn-scene-2',
  'can-ho-1pn-scene-3',
  'can-ho-1pn-scene-4',
  'can-ho-1pn-scene-5',
  'can-ho-1pn-scene-6',
];

export const mikaTopMenu = [
  {
    id: 'mika-topview-tang-07',
    title: 'Topview Mika + Gali Tầng 06',
  },
  {
    id: 'mika-topview-tang-15',
    title: 'Topview Mika + Gali Tầng 12',
  },
  // {
  //   id: 'mika-topview-tang-22',
  //   title: 'Mika Topview Tầng 18',
  // },
  {
    id: 'mika-topview-tang-25',
    title: 'Topview Mika + Gali Tầng 18',
  },
  {
    id: 'mika-topview-tang-27',
    title: 'Topview Mika + Gali Tầng 24',
  },
];
